import React from 'react';
import { GdrpContext } from './GdprContext';

export default function useGdprIsAllowed(key: string) {
    const { settings } = React.useContext(GdrpContext);

    for (const service of settings.services) {
        if (service.name === key) {
            return service.allowed;
        }
    }

}